import Hidden from "@material-ui/core/Hidden";
import * as React from "react";

interface BreakpointProps {
    children: React.ReactNode;
    desktop?: boolean;
    mobile?: boolean;
}

export const Breakpoint = (props: BreakpointProps) => {
    const { children, desktop = false, mobile = false } = props;

    if (desktop && mobile) {
        throw new Error(
            "Breakpoint component cannot have both desktop and mobile specified"
        );
    }

    if (!desktop && !mobile) {
        throw new Error(
            "Breakpoint component must have one of desktop or mobile specified"
        );
    }

    // use built-in material breakpoints for desktop/mobile switch
    // NOTE: Hidden does the opposite!
    // smDown = mobile
    // mdUp = desktop
    return (
        <Hidden smDown={desktop && !mobile} mdUp={!desktop && mobile}>
            {children}
        </Hidden>
    );
};
